// Render billing setting fields
import React from "react";
import BillingAddressFields from "./BillingAddressFields";
import Button from "./Button";
import EmailAddressField from "./EmailAddressField";
import FormActions from "./FormActions";
import FormErrors from "./FormErrors";
import LevelDescription from "./LevelDescription";
import Loader from "./Loader";
import PaymentMethodFields from "./PaymentMethodFields";
import Title from "../common/Title";
import LegacyLevel from "./LegacyLevel";

const BillingSettingFields = (props) => {
  return (
    <div className="render-billing-settings">
      <div className="with-spacebetween">
        <Title title="Billing settings" />
        <Button action="editProfile" />
      </div>

      {props.memberLevel == 0 ? (
        <div className="page-surface">
          <LevelDescription level={props.levels[props.memberLevel]} />
        </div>
      ) : (
        <div className="page-surface">
          <h2>{props.levels[props.memberLevel].name} member</h2>
          {props.memberLevel == 2 && props.member.legacy === "true" ? (
            <div>
              <h5>
                {" "}
                <span className="selector-legacy-strikethrough">
                  {props.levels[props.memberLevel].priceLabel}
                </span>
                $8/month
              </h5>
              <LegacyLevel />
              <Button action="changeLevel" />
            </div>
          ) : (
            <div>
              <h5>{props.levels[props.memberLevel].priceLabel}</h5>
              <Button action="changeLevel" />
            </div>
          )}

          <div className="half-width with-sections">
            <h3>Payment method</h3>
            <PaymentMethodFields
              savedBilling={props.savedBilling}
              chosenMethod={props.chosenMethod}
              handleChosenMethodSaved={props.handleChosenMethodSaved}
              handleChosenMethodNew={props.handleChosenMethodNew}
            />
            <EmailAddressField />
            <BillingAddressFields />
            {props.formError && <FormErrors message={props.formError} />}
            <FormActions>
              <div className="with-spacebetween">
                <div>
                  <Button action="save" ref={props.submit} />
                  <Loader ref={props.loader} />
                </div>
                {/* TODO: ADD CANCELLATION
            <a className="form-details" href="/members/cancel">
              Cancel membership
            </a>*/}
              </div>
            </FormActions>
          </div>
        </div>
      )}
    </div>
  );
};
export default BillingSettingFields;
